export const offerTypes = {
  hotel_only: 'S',
  holiday: 'A',
  one_way_flight: 'C1',
  two_ways_flight: 'C2'
};



// WEBPACK FOOTER //
// ./app/javascript/common/objects/offer_types.js